export class UploadDelete {
    constructor(optionalOptions = {}) {
        this._inputsDelete = document.querySelectorAll('.base-form-upload-input-delete');

        if (!this._inputsDelete) {
            this.destructor();
            return true;
        }

        let img
        let attrEmpty

        for (let i = 0; i < this._inputsDelete.length; ++i) {
            let buttonDelete = this._inputsDelete[i];
            buttonDelete.addEventListener('click', (event) => {
                img = buttonDelete.parentNode.querySelector('img')
                attrEmpty = img.dataset.empty

                img.src = attrEmpty;
                buttonDelete.parentNode.classList.add('upload-button--empty');
                buttonDelete.parentNode.parentNode.querySelector('.upload-input').value = '';
            });
        }
    }

    destructor() {
        this._inputsDelete = null;
    }
}

export default new UploadDelete();